import { render, staticRenderFns } from "./linkedInCheck.vue?vue&type=template&id=f855bd1e&scoped=true"
import script from "./linkedInCheck.vue?vue&type=script&lang=js"
export * from "./linkedInCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f855bd1e",
  null
  
)

export default component.exports